import { render, staticRenderFns } from "./AppDraggableItem.vue?vue&type=template&id=f75f1e1c&scoped=true&"
import script from "./AppDraggableItem.vue?vue&type=script&lang=js&"
export * from "./AppDraggableItem.vue?vue&type=script&lang=js&"
import style0 from "./AppDraggableItem.vue?vue&type=style&index=0&id=f75f1e1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75f1e1c",
  null
  
)

export default component.exports